import React from "react";
import { Navigate, useLocation } from "react-router-dom";
const PrivateElement = ({ children }) => {
  let location = useLocation();

  const menusString = sessionStorage.getItem("menus");
  let hasAccessToMenu =
    (!!menusString && menusString.includes(`"${window.location.pathname}"`)) ||
    window.location.pathname === "/dashboard";

  return sessionStorage.getItem("token") && hasAccessToMenu ? (
    children
  ) : (
    <Navigate
      to={`/?redirectUrl=${window.location.pathname + window.location.search}`}
      state={{ from: location }}
    />
  );
};

export default PrivateElement;
